module.exports = __webpack_public_path__ + "img/cszq_bg_logo.a7f7fd9f.jpg";